import { config } from "../config";
const noOverrideCode = "0";
export const init = (apiConfig) => {
    const locale = apiConfig.localeSettings.localeCodeOverride !== noOverrideCode
        ? apiConfig.localeSettings.localeCodeOverride
        : apiConfig.localeSettings.currentLocale;
    config.set(Object.assign(Object.assign({}, config.get), { locale }));
};
//# sourceMappingURL=init.js.map